<template>
  <div>
    <v-row v-if="festival.acf">
      <v-col cols="12">
      <h2 class="text-h4 primary--text mb-4 text-uppercase">
        {{ formatDate(festival.acf?.start_date_source.formatted_value, festival.acf?.end_date_source.formatted_value) }}
      </h2>
    </v-col>

    <v-col cols="12">
      <div class="grayTest px-8 py-10 mb-10">
        <div v-html="festival.content.rendered"></div>
        <!-- <ComingMaps
          v-bind:title="`Retrouver le festival`"
        /> -->
      </div>
    </v-col>

    <v-col cols="12">
      <h3 class="text-h5">
        Nos tarifs billetterie
      </h3>
    </v-col>
    <v-col v-for="(a, index) in pricingTickets" :key="index" cols="12" sm="6" lg="3">
      <div class="greyCol px-5 pt-8 pb-2 d-flex flex-column align-center">
        <h4 class="mb-4 text-subtitle-1">{{a.title}}</h4>
        <div class="d-flex align-start">
          <p class="text-h3">{{a.price}}</p><p class="text-h4 ml-1">€</p>
        </div>
        <p class="text-caption font-italic text-center mt-2">{{ a.text }}</p>
      </div>
    </v-col>

    <v-col v-if="ticketOpen" cols="12" sm="4" lg="3">
      <v-btn
        block
        rounded
        class="secondary mt-2"
        elevation="2"
        x-large
        :href="ticketLink"
        target="_blank"
      >réserver</v-btn>
    </v-col>
    <v-col v-if="ticketOpen" cols="12" sm="5">
      <v-btn
        text
        color="primary"
        :to="{ name: 'politique' }"
        class="pt-sm-8"
      >
        politique de billetterie
      </v-btn>
    </v-col>

    <v-col cols="12" class="pt-15">
      <h3 class="text-h5">
        Nos tarifs d'adhésion
      </h3>
    </v-col>
    <v-col v-for="(a, index) in pricingAdhesion" :key="index" cols="12" sm="4">
      <div class="greyCol px-5 pt-8 pb-2 d-flex flex-column align-center">
        <h4 class="mb-4 text-subtitle-1">{{a.title}}</h4>
        <div class="d-flex align-start">
          <p class="text-h3">{{a.price}}</p><p class="text-h4 ml-1">€</p>
        </div>
        <p class="text-caption font-italic text-center mt-2">{{ a.text }}</p>
      </div>
    </v-col>
    <!-- <p class="text-body-2 mb-12" v-html="festival.content?.rendered"></p> -->

    <!-- <h3 class="text-h5 primary--text mb-4 text-uppercase">Billetterie et adhésion (saison 2022 - 2023)</h3>
    <h5 class="text-subtitle-2 mt-5 font-weight-bold">Billetterie et adhésion (saison 2022 - 2023)</h5> -->

    <v-col v-if="ticketOpen" cols="12" sm="4" lg="3">
      <v-btn
        block
        rounded
        class="secondary mt-2"
        elevation="2"
        x-large
        :href="ticketLink"
        target="_blank"
      >réserver</v-btn>
    </v-col>
    <v-col v-if="ticketOpen" cols="12" sm="5">
      <v-btn
        text
        color="primary"
        :to="{ name: 'politique' }"
        class="pt-sm-8"
      >
        politique de billetterie
      </v-btn>
    </v-col>

    <v-col cols="12" v-if="actuFestival.length > 0" class="mb-5 mt-10">
      <TitleAppBar
        v-bind:title="'Actualités associées'"
        v-bind:littlePadding="true"
      />
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          xl="3"
          v-for="actu in actuFestival"
          :key="actu.id"
        >
          <ActuFestivalCard
            v-bind:slug="actu.slug"
            v-bind:id="actu.id"
            v-bind:title="actu.title?.rendered"
            v-bind:imgUrl="actu.acf?.image"
          />
        </v-col>
      </v-row>
    </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <p class="text-body-1 text--secondary">Aucun festival à venir pour le moment.</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import ComingMaps from "../../../components/maps/comingMaps";
import ActuFestivalCard from "../../../components/cards/actuFestivalCard";
import { APIService } from "../../../APIService";
const apiService = new APIService();
import moment from "moment";

export default {
  name: "Info",

  components: {
    // ComingMaps,
    ActuFestivalCard
  },

  data: () => ({
    pricingTickets: [
      { 
        title: "Tarif réduit", 
        price: 5,
        text: "- de 18ans, adhérent" 
      },
      { 
        title: "Tarif pour toutes et tous", 
        price: 10,
        text: "Ce tarif est, comme son nom l'indique, pour chacun et chacune, sans justification nécessaire. La compagnie souhaite le maintenir pour rester accessible à toutes et tous !" 
      },
      { 
        title: "Tarif plein", 
        price: 12,
        text: "Un tarif qui évolue pour répondre aux réalités économiques de la compagnie. Il permet également de maintenir les autres tarifs pour que le théâtre reste accessible à tout le monde." 
      },
      { 
        title: "Tarif soutien", 
        price: 15,
        text: "Une jolie manière de soutenir notre théâtre !" 
      },
      { 
        title: "Gratuité", 
        price: 0,
        text: "pour les enfants de moins de 7 ans" 
      },
    ],
    pricingAdhesion: [
      { 
        title: "Tarif réduit", 
        price: 5,
        text: "étudiant, chômeur" 
      },
      { 
        title: "Tarif plein", 
        price: 10,
        text: "" 
      },
      { 
        title: "Tarif soutien", 
        price: 20,
        text: "En choisissant ce tarif vous pérennisez l’activité de la compagnie et son accessibilité" 
      }
    ],
    actuFestival: [],
    pastFestival: [],
    festival: {},
    numberFestivalActu: 3,
    ticketOpen: false,
    ticketLink: ""
  }),

  mounted() {
    this.onResize();
    apiService.getAll("wp/v2/pages/1031").then(data => {
      this.ticketOpen = data.acf.activate_billeterie
      this.ticketLink = data.acf.link_billetterie
    })

    apiService.getAll("wp/v2/festival").then(data => {
      let today = moment();
      
      this.festival = data.length > 0 ? data[0] : {};
      this.pastFestival = data.filter(fest =>
        moment(fest.acf.start_date, "DD/MM/YYYY").isBefore(today)
      );
    });
    apiService.getAll("wp/v2/posts").then(data => {
      this.actuFestival = data.filter(actu => actu.acf?.article_lie_au_festival);
    });
  },

  methods: {
    dateFormat(data, format) {
      return moment(String(data), "DD/MM/YYYY HH:mm")
        .locale("fr")
        .format(format);
    },
    formatDate(start, end) {
      if (this.dateFormat(start, "MMMM") === this.dateFormat(end, "MMMM")) {
        return (
          "Du " +
          this.dateFormat(start, "D") +
          " au " +
          this.dateFormat(end, "D MMMM YYYY")
        );
      } else {
        return (
          "Du " +
          this.dateFormat(start, "D MMMM") +
          " au " +
          this.dateFormat(end, "D MMMM YYYY")
        );
      }
    },

    onResize() {
      const width = window.innerWidth;
      if (width < 600) {
        this.numberFestivalActu = 1;
      } else if (width >= 600 && width < 1264) {
        this.numberFestivalActu = 2;
      } else if (width >= 1264 && width < 1904) {
        this.numberFestivalActu = 2;
      } else if (width > 1904) {
        this.numberFestivalActu = 3;
      } else {
        this.numberFestivalActu = 3;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  list-style: inside ". ";
  padding: 0;
}

.greyCol {
  background-color: var(--v-grey-base);
  height: 100%;
}

.grayTest {
  background-color: var(--v-grey-base);
}
</style>